<template>
    <div class="my-auto mx-auto xl:ml-20 w-full sm:w-3/4 lg:w-2/4 xl:w-auto">

        <img alt="Adamo login Logo" class="-intro-x w-1/2 xl:hidden mx-auto mb-8" src="/dist/images/adamo-logo-new.png">

        <div class="bg-white px-5 sm:px-8 py-8 shadow-md xl:shadow-none ">

            <div v-bind:class="flipped ? 'flip-container flipped': 'flip-container'">
                <div class="flipper">
                    <!--                INICIO SESION-->
                    <div class="front">
                        <h2 class="font-bold text-2xl xl:text-3xl text-center" :class="{'intro-x':!flipped}">Iniciar Sesión</h2>
                        <div class=" text-lg text-center xl:hidden" :class="{'intro-x':!flipped}">Bienvenido a Universo Adamo.</div>
                        <div class=" mt-8" :class="{'intro-x':!flipped}">
                            <form @keyup.enter="login">
                                <input v-model="form.email" type="text" class="login__input input input--lg border border-gray-300 block" :class="{ 'border-theme-6': $getErrorClasses(errorMessages, 'email') }" placeholder="Email">
                                <div v-if="$isset(errorMessages)" class="w-5/6 text-theme-6 mt-2" v-for="message in errorMessages.email">{{ message }}</div>
                                <input v-model="form.password" type="password" class="login__input input input--lg border border-gray-300 block mt-4" :class="{ 'border-theme-6': $getErrorClasses(errorMessages, 'password') }" placeholder="Contraseña">
                                <div v-if="$isset(errorMessages)" class="w-5/6 text-theme-6 mt-2" v-for="message in errorMessages.password">{{ message }}</div>
                            </form>
                        </div>
                        <div class="flex text-gray-700 text-xs sm:text-sm mt-4" :class="{'-intro-x':!flipped}">
                            <div class="flex items-center mr-auto">
                                <input v-model="form.remember" type="checkbox" class="input border mr-2" id="remember-me">
                                <label class="cursor-pointer select-none" for="remember-me">Recordar</label>
                            </div>
                            <p class="cursor-pointer" v-on:click="flipped=true">¿Olvidaste tu contraseña?</p>
                        </div>
                        <div class=" mt-5 xl:mt-8 flex justify-center xl:justify-start" :class="{'intro-x':!flipped}">
                            <button @click="login" class="button button--lg w-full text-white bg-theme-1 xl:mr-3">
                                <template v-if="!requestState">Iniciar Sesión</template>
                                <animated-icon v-else icon="oval" color="white" class="w-5 h-5 block mx-auto"></animated-icon>
                            </button>
                        </div>
                    </div>
                    <!--                OLVIDASTE CONTRASEÑA-->
                    <div class="back">
                        <h2 class="font-bold text-2xl xl:text-3xl text-center xl:text-left" :class="{'intro-x':flipped}">Restablecer Contraseña</h2>

                        <div v-if="resetOK" class="mt-4 p-4 bg-green-400 items-center text-white text-center text-lg flex lg:inline-flex" role="alert">
                            Link para restablecer contraseña enviado.
                        </div>

                        <div v-else>

                            <div class="text-lg" :class="{'intro-x':flipped}">Introduce tu email para solicitar el cambio de contraseña.</div>

                            <div class="mt-8" :class="{'-intro-x':flipped}">
                                <form @keyup.enter="reset">
                                    <input v-model="frmReset.email" type="text" class="login__input input input--lg border border-gray-300 block" :class="{ 'border-theme-6': $getErrorClasses(errorMessages, 'email') }" placeholder="Email">
                                    <div v-if="$isset(errorMessages)" class="w-5/6 text-theme-6 mt-2" v-for="message in errorMessages.email">{{ message }}</div>
                                </form>
                            </div>

                            <div class="mt-5 xl:mt-8 flex justify-center xl:justify-start" :class="{'intro-x':flipped}">
                                <button @click="reset" class="button button--lg w-full xl:w-32 text-white bg-theme-1 xl:mr-3">
                                    <template v-if="!requestState">Restablecer</template>
                                    <animated-icon v-else icon="oval" color="white" class="w-5 h-5 block mx-auto"></animated-icon>
                                </button>
                                <button class="button button--lg w-full xl:w-32 text-gray-700 border border-gray-300 mt-3 xl:mt-0" v-on:click="flipped=false">Iniciar Sesión</button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            page: String
        },
        data() {
            return {
                form: {
                    email: '',
                    password: '',
                    remember: false
                },
                frmReset: {
                    email: '',
                },
                flipped: false,
                requestState: false,
                resetOK: false,
                errorMessages: []
            }
        },
        methods: {
            async login() {
                this.requestState = true
                await this.$delay(1000);

                this.$req.auth.login(this.form).then(async res => {
                    window.location.href = '/inicio'
                }).catch(err => {
                    this.requestState = false
                    this.form.password = ''
                    this.errorMessages = err.response.data.errors
                })
            },
            async reset() {
                this.requestState = true
                await this.$delay(1000)

                this.$req.auth.email(this.frmReset).then(async res => {
                    this.resetOK = true;
                }).catch(err => {
                    this.requestState = false;
                    this.errorMessages = err.response.data.errors
                })
            }
        },
        mounted: function () {
            this.flipped = this.page === 'reset';
        }
    }
</script>


<style type='text/css' scoped>
    i.frontFlipBtn,
    i.backFlipBtn {
        position: absolute;
        right: 20px;
        top: 20px;
        color: #FFFFFF;
    }

    i.backFlipBtn {
        -webkit-transform: rotateY(-180deg);
        -moz-transform: rotateY(-180deg);
        -o-transform: rotateY(-180deg);
        -ms-transform: rotateY(-180deg);
        transform: rotateY(-180deg);
    }

    .flip-container {
        -webkit-perspective: 1000;
        -moz-perspective: 1000;
        -o-perspective: 1000;
        perspective: 1000;
    }

    .flip-container {
        min-height: 120px;
    }

    .flipper {
        -moz-transform: perspective(1000px);
        -moz-transform-style: preserve-3d;
        position: relative;
    }

    .front,
    .back {
        -webkit-backface-visibility: hidden;
        -moz-backface-visibility: hidden;
        -o-backface-visibility: hidden;
        backface-visibility: hidden;
        -webkit-transition: 0.6s;
        -webkit-transform-style: preserve-3d;
        -moz-transition: 0.6s;
        -moz-transform-style: preserve-3d;
        -o-transition: 0.6s;
        -o-transform-style: preserve-3d;
        -ms-transition: 0.6s;
        -ms-transform-style: preserve-3d;
        transition: 0.6s;
        transform-style: preserve-3d;
        top: 0;
        left: 0;
        width: 100%;
    }

    .back {
        -webkit-transform: rotateY(-180deg);
        -moz-transform: rotateY(-180deg);
        -o-transform: rotateY(-180deg);
        -ms-transform: rotateY(-180deg);
        transform: rotateY(-180deg);
        position: absolute;
    }

    .flip-container.flipped .back {
        -webkit-transform: rotateY(0deg);
        -moz-transform: rotateY(0deg);
        -o-transform: rotateY(0deg);
        -ms-transform: rotateY(0deg);
        transform: rotateY(0deg);
    }

    .flip-container.flipped .front {
        -webkit-transform: rotateY(180deg);
        -moz-transform: rotateY(180deg);
        -o-transform: rotateY(180deg);
        -ms-transform: rotateY(180deg);
        transform: rotateY(180deg);
    }

    .front {
        z-index: 2;
    }
</style>
